<template>
  <el-form-item prop="variableArr" ref="formItem" verify :rules="versionRules" class="sky-server-config">
    <div class="sky-subsystem-version">
      <span v-for="(item, index) in version" :key="index">
        <input
          v-model="version[index]"
          :placeholder="$t(placeholderDes(index))"
          :class="['sky-subsystem-version__item', 'el-input__inner']"
          :ref="'input' + index"
          :id="index"
          @keyup="handleKeyUp"
          @keydown="handleKeydown"
        />
        <span v-if="index == 0"> _V </span>
        <span v-else-if="index == 2"> _ </span>
        <span v-else-if="index !== version.length - 1"> . </span>
      </span>
    </div>
  </el-form-item>
</template>
<script type="text/babel">
import { Input, InputNumber, Button } from 'element-ui'
import { caret } from 'sk-ui/src/utils/util'
export default {
  name: 'SkyProductVersionName',
  inject: ['elForm'],
  components: {
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    [Button.name]: Button
  },
  props: {
    value: {
      type: [String, Array],
      default() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledMain: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      version: ['', '', '', '']
    }
  },
  computed: {
    versionRules() {
      const validatorBranch = (rule, value, callback) => {
        let hasError = false
        let hasSet = false
        for (const data of this.version) {
          if (!!data && data !== '') {
            hasSet = true
          }
        }
        if (hasSet) {
          for (const index in this.version) {
            const data = this.version[index]
            if (!data || data == '') {
              hasError = true
              callback(new Error(this.$t('请输入未填项')))
            }
            if (!hasError && index == 0) {
              const pattern = new RegExp(/^[a-zA-Z-]+$/)
              if (!pattern.test(data)) {
                hasError = true && callback(new Error(this.$t('请输入符合规范的产品类型，如RCO')))
              }
            }
            if (!hasError && (index == 1 || index == 2)) {
              const pattern = new RegExp(/^\d+$/)
              if (!pattern.test(data)) {
                hasError = true && callback(new Error(this.$t('请输入符合规范的版本号，仅允许输入数字')))
              }
            }
            if (!hasError && index == 3) {
              const pattern = new RegExp(/^[a-zA-Z0-9]+$/)
              if (!pattern.test(data)) {
                hasError = true && callback(new Error(this.$t('请输入符合规范的版本号，如R1')))
              }
            }
          }
        }
        if (!hasError) {
          callback()
        }
      }
      return [[{ validator: validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  watch: {
    value(newVal) {
      if (!Array.isArray(newVal)) {
        // RCO_V2.0_R1
        const data1 = newVal.split('_V')[0]
        const data2 = newVal.split('_V')[1].split('.')[0]
        const data3 = newVal
          .split('_V')[1]
          .split('.')[1]
          .split('_')[0]
        const data4 = newVal
          .split('_V')[1]
          .split('.')[1]
          .split('_')[1]
        this.version = [data1, data2, data3, data4]
      }
    },
    version(newVal) {
      this.$emit('input', newVal)
    }
  },
  mounted() {
    // this.$cellArray = []
    // this.version.forEach((item, index) => {
    //   this.$cellArray.push(this.$refs['input' + index][0])
    // })
  },
  methods: {
    placeholderDes(index) {
      switch (index) {
        case 0:
          return '产品名'
        case 1:
          return '产品版本'
        case 2:
          return '产品版本'
        case 3:
          return '产品版本'
        default:
          return ''
      }
    },
    handleKeyUp(e) {
      if (e.keyCode === 9 || e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 110 || e.keyCode === 190) {
        return
      }
      this.elForm.validateField('name')
    },
    handleKeydown(e) {
      const keyCode = e.keyCode
      const index = parseInt(e.target.id, 10)
      const nextRefs = this.$refs['input' + (index + 1)]
      const preRefs = this.$refs['input' + (index - 1)]
      let next_cell = nextRefs && nextRefs[0]
      let prev_cell = preRefs && preRefs[0]
      // 键盘码110代表. 190代表 >.---当键盘码为这两种时,跳至下一输入框中,并选中该输入框中的值
      if (keyCode === 110 || keyCode === 190) {
        if (next_cell) {
          // 非最后一个输入框时，跳至下一输入框
          // 默认全选,方便输入的时候修改
          next_cell.select()
        }
        e.preventDefault() // 不论是否为最后一个输入框,防止默认事件发生,否则输入框中会出现 ...
        return
      }
      // 1.当为向左键(37),且光标位置位于输入框起始位置时,则跳至前一输入框中;
      // 2.当为backspace键,且已回删至输入框起始位置 跳至前已输入框中
      if (this.isPrevous(keyCode, e.target, prev_cell)) {
        caret(prev_cell.value.length, null, prev_cell)
        e.preventDefault() // 防止默认事件发生,否则输入框中的回退光标位置会有问题
      }
    },
    isPrevous(keyCode, thisInput, prev_cell) {
      const cursorIsAtFirstPlace = caret(null, null, thisInput)[0] === 0
      return (
        ((keyCode === 37 && cursorIsAtFirstPlace) ||
          (keyCode === 8 && cursorIsAtFirstPlace && thisInput.value.length === 0)) &&
        prev_cell
      )
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(subsystem-version) {
  width: 800px;
  margin-bottom: 2px !important;

  @include e(disabled) {
    background-color: $--disabled-fill-base !important;
    border-color: $--disabled-border-base !important;
    color: $--font-color-disabled-base !important;
    cursor: not-allowed !important;
  }

  @include e(link) {
    margin-left: 5px;
  }
  @include e(item) {
    width: 115px !important;
  }
}
</style>
